import { configureStore, createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    email: null,
    isLoggedIn: false,
  },
  reducers: {
    login(state, action) {
      state.email = action.payload.email;
      state.isLoggedIn = true;
    },
    logout(state) {
      state.email = null;
      state.isLoggedIn = false;
    },
  },
});

export const { login, logout } = userSlice.actions;

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
  },
});

export default store;
